import * as React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { pageMap } from '../../../paths';
import { useSelector } from '../../../state';
import { selectors } from '../../../state/editor';
import { getOnboardingUrl } from '../../../utils';
import { ButtonLink } from '../../buttons';
import { StepContainer } from '../Container';
import { StepHeading } from '../step-heading';

export const GoToOnboardingStep: React.FC = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const userId = searchParams.get('bruker');
  const { bankSelection, id } = useSelector(e => ({
    id: e.founding.id,
    bankSelection: e.founding.bankSelection,
  }));
  const { canOnboard } = useSelector(e => ({
    canOnboard: selectors.userCanOnboard(e, userId ?? e.editor.formOwner),
  }));
  const onboardingUrl = getOnboardingUrl(id, bankSelection);

  return (
    <StepContainer>
      <StepHeading>Åpne konto</StepHeading>

      {canOnboard ? (
        <>
          <p>
            For å bli registrert må selskapet ha en bedrifts&shy;konto, som du
            skal sette aksje&shy;kapitalen på.
          </p>

          <p>
            <b>Dere må fullføre bestillingen i Folio</b>
            <br />
            Du valgte konto fra Folio, men fullførte ikke søknaden. Folio
            bedrifts&shy;konto er fri for små&shy;gebyrer, gratis første
            måneden, og uten bindings&shy;tid.{' '}
            <Link
              to={{ pathname: pageMap.findOutMore, search: location.search }}
            >
              Les om bedriftskonto fra Folio
            </Link>
            .
          </p>
          <p>
            Senere i prosessen kan du sette opp regnskap med Fiken. Dersom du
            velger å opprette konto hos både Fiken og Folio blir det automatisk
            opprettet en integrasjon mellom bank og regnskap for deg.
          </p>

          <p>
            <ButtonLink href={onboardingUrl}>
              Fullfør søknaden i Folio
            </ButtonLink>
          </p>
        </>
      ) : (
        <>
          <p>
            Før bedriften kan registreres, må daglig leder eller styreleder
            bestille konto til selskapet. Vi har sendt lenke på e-post til rett
            person.
          </p>

          <p>
            <b>Bankkonto oppretter du enkelt med Folio</b>
            <br />
            Dette er en bedrifts&shy;konto som er fri for små&shy;gebyrer,
            gratis første måneden, og uten bindings&shy;tid.{' '}
            <Link
              to={{ pathname: pageMap.findOutMore, search: location.search }}
            >
              Les om bedriftskonto fra Folio
            </Link>
            .
          </p>
          <p>
            Senere i prosessen kan du sette opp regnskap med Fiken. Dersom du
            velger å opprette konto hos både Fiken og Folio blir det automatisk
            opprettet en integrasjon mellom bank og regnskap for deg.
          </p>
        </>
      )}
    </StepContainer>
  );
};
